<template lang="pug">
div
  v-overlay(v-if="loading" :value="loading" absolute)
    v-progress-circular(indeterminate)

  v-expand-transition
    div.pl-9(v-if="!loading")
      v-card.d-flex.mt-2(key="add"  outlined)
        v-btn.rounded.mr-2(
          @click="dialog = true"
          fab
          tile
          x-small
          color="success"
        )
          v-icon mdi-plus
        p.title.mb-0 Добавить вопрос

      div(v-for="role in roles" :key="role.id")
        v-card(outlined).d-flex.mt-2
          v-btn.rounded.mr-2(
            @click="toggleRole(role.id)"
            fab
            tile
            x-small
            color="secondary"
          )
            v-icon mdi-chevron-down
          p.title.mb-0.mr-auto {{ role.name }}
          v-btn.rounded(@click="editProject(role)" fab tile x-small text)
            v-icon mdi-pencil
          v-btn.rounded(@click="deleteProject(role.id)" fab tile x-small color="error")
            v-icon mdi-close
        questions(
          v-if="role.id === selectedRole"
          :project-role-id="projectRoleId"
          :parent-id="role.id"
          :has-child="role.has_child"
        )
      v-dialog(v-model='dialog' max-width='500px' dark)
        v-card.pa-5
          p.text-h5 {{ title }}
          v-text-field(
            required
            v-model="form.name" filled label="Название вопроса")
          v-select(
            v-if="!parentId"
            v-model="form.send_type"
            :items="sendTypeItems"
            filled
            label="Кто отвечает"
          )
          v-btn.mr-4(
            :disabled="!form.name"
            color="success"
            @click="saveProject"
          ) Сохранить
          v-btn(text @click='dialog = false') Отменить
  confirm-form-dialog(
    v-model="deleteProjectDialog"
    message="Действительно удалить?"
    @accept="acceptDeleteProject"
  )
</template>

<script>
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';

import { SEND_TYPES, SEND_TYPE_NAMES } from '@/constants';
import SelectProject from '@/components/inputs/SelectProject.vue';
import { CRUDQuestionCategory } from '@/services/API/_crud';

const DEFAULT_FORM = {
  name: '',
  send_type: null,
};

export default {
  name:'Questions',
  components: {  ConfirmFormDialog, SelectProject },
  props:{
    parentId: { type:Number, required: false, default:null },
    projectRoleId: { type:Number, required: false, default:null },
    hasChild: { type:Boolean, required: false, default:true },
  },
  data() {
    return {
      roles: [],
      dialog: false,

      deleteProjectDialog: false,
      deleteProjectId: null,

      loading: false,

      selectedRole: null,

      form: { ...DEFAULT_FORM },

    };
  },
  computed: {
    title() {
      return this.form.id ? 'Изменение вопроса' : 'Создание вопроса';
    },
    sendTypeItems() {
      return Object.keys(SEND_TYPES).map((key) => ({
        value: SEND_TYPES[key],
        text: SEND_TYPE_NAMES[SEND_TYPES[key]],
      }));
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (!this.hasChild) return;

      const params = {
        'per-page': -1,
        'sort': '-id',
        'search[parent_id]': this.parentId,
        'search[project_role_id]': this.projectRoleId,
        'expand': 'has_child',
      };
      if (this.parentId) delete params['search[project_role_id]'];

      this.loading = true;

      try {
        const response = await CRUDQuestionCategory.getAll(params);
        this.roles = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
      this.loading = false;
    },

    deleteProject(id) {
      this.deleteProjectDialog = true;
      this.deleteProjectId = id;
    },

    editProject(data) {
      this.form = { ...data };
      this.dialog = true;
    },

    async acceptDeleteProject() {
      this.deleteProjectDialog = false;
      await CRUDQuestionCategory.delete(this.deleteProjectId);

      this.roles = this.roles.filter(({ id }) => id !== this.deleteProjectId);
    },

    async saveProject() {
      this.dialog = false;

      const params = {
        ...this.form,
        project_role_id: this.projectRoleId,
        parent_id: this.parentId,
      };

      if (this.parentId) delete params.project_role_id;
      if (!params.send_type) delete params.send_type;
      if (!params.parent_id) delete params.parent_id;

      let response;

      if (this.form.id) {
        response = await CRUDQuestionCategory.update(this.form.id, params);
        const index = this.roles.findIndex(({ id }) => id === this.form.id);
        const newProjects = [...this.roles];
        newProjects[index] = response.data.data;
        this.roles = newProjects;
      } else {
        response = await CRUDQuestionCategory.create(params);
        this.roles.unshift(response.data.data);
      }

      this.form = { ...DEFAULT_FORM };
    },
    toggleRole(id) {
      this.selectedRole  = this.selectedRole === id ? null : id;
    },
  },
};
</script>
